import { types, Instance } from 'mobx-state-tree';
const { model, string, maybeNull, maybe } = types;

export const syncGithubUserModel = model('syncUserModel ', {
  name: maybeNull(string),
  email: maybeNull(string),
  created_at: maybeNull(string),
  updated_at: maybeNull(string),
  githubId: maybeNull(string),
  login: maybeNull(string),
});
export type IsyncGithubUserModel = Instance<typeof syncGithubUserModel>;

export const SelectedUserModel = model('SelectedUserModel', {
  githubIds: maybe(string),
});
export type ISelectedUserModel = Instance<typeof SelectedUserModel>;

export const OrganisationModel = model('OrganisationModel', {
  login: maybeNull(string),
});
export type IOrganisationModel = Instance<typeof OrganisationModel>;

export const syncGithubDepartmentModel = model('syncDepartmentModel ', {
  name: maybeNull(string),
  description: maybeNull(string),
  githubOrgId: maybeNull(string),
  login: maybeNull(string),
});
export type IsyncGithubDepartmentModel = Instance<typeof syncGithubDepartmentModel>;
